// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"1a4a8386","143":"6ff76b18","192":"48ac79be","295":"0f02a037","349":"cdbc96d0","351":"80fa57a2","592":"6b2364d8","655":"78947da3","813":"b677c570","866":"4da9f56d","927":"3319c086","963":"3c3d57bf"}[chunkId] + ".chunk.js";
};